import merge from 'lodash/merge';

/**
 * The key used to persist leadData into sessionStorage
 * @type {string}
 */
export const STORAGE_KEY = 'leadPersonalDetails';

/**
 * Available privacy flags
 *
 * @type {string[]}
 */
export const PRIVACY_FLAGS = ['privacy', 'profiling', 'marketing', 'third_parties'];

/**
 * Allowed hidden fields in the session storage
 *
 * @type {string[]}
 */
export const ALLOWED_HIDDEN_FIELDS_IN_STORAGE = [
    'dkwp[GAcampaign]',
    'dkwp[GAsource]',
    'dkwp[GAmedium]',
    'dkwp[GAterm]',
    'dkwp[GAcontent]',
    'dkwp[sourcePage]',
];

/**
 * Privacy flag true value
 *
 * @type {string}
 */
const TRUE_VALUE = 'Y';

/**
 * Privacy flag falsy value
 *
 * @type {string}
 */
const FALSE_VALUE = 'N';

/**
 * Return an object where all keys with brackets (ie: dkwp[name])
 * Strips the brackets from a key of type dkwp[name], returning
 * @param {Object} data
 */
export const stripDkwpPrefix = (data = {}) => {
    const accumulator = {};

    Object.keys(data).forEach((key) => {
        const match = key.match(/\[([^\\]+)\]/);
        const computedKey = Array.isArray(match) && match.length ? match[1] : key;

        accumulator[computedKey] = data[key];
    });

    return accumulator;
};

/**
 * Return an object with all the key/value pairs from a FormData object.
 *
 * @param {Object} formData
 */
export const getObjectFromFormData = (formData) => {
    const accumulator = {};

    formData.forEach((value, key) => {
        accumulator[key] = value;
    });

    return accumulator;
};

/**
 * Set, if present, each privacy flag's value to Y if the former is true, to N otherwise.
 *
 * @param data
 */
export const setPrivacyFlagsToString = (data = {}) => {
    const accumulator = {};

    PRIVACY_FLAGS.forEach((flag) => {
        if (Object.prototype.hasOwnProperty.call(data, flag)) {
            accumulator[flag] = data[flag] ? TRUE_VALUE : FALSE_VALUE;
        }
    });

    return merge({}, data, accumulator);
};

/**
 * Persists the lead data into session storage.
 *
 * @param {Object} data
 */
export const persistLeadData = (data) => window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
